import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <h2 className="section-title">Who We Are</h2>
        <p className="about-description">
          {/* Independent research firm applying quantitative methods, market-dynamics forecasting, and AI/ML techniques to study prediction markets and consumer behavior. We build experimental forecasting models, publish evidence-based research, and explore how statistical and AI-driven approaches can deepen understanding of signals within markets. */}
          Independent research firm applying AI/ML and quantitative methods to build forecasting models, design novel systematic trading strategies, and analyze signals across betting and prediction markets.
        </p>
      </div>
    </section>
  );
};

export default About;
